import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import TopPage from "./pages/TopPage";
import LoginPage from "./pages/LoginPage";
import WorkContentsCreatePage from "./pages/work-contents/WorkContentsCreatePage";
import WorkContentsEditPage from "./pages/work-contents/WorkContentsEditPage";
import WorkContentsInterruptCreatePage from "./pages/work-contents/WorkContentsInterruptCreatePage";
import LicensePage from "./pages/LicensePage";
import { SnackbarProvider } from "./components/snackbar/SnackbarProvider";

/**
 * ルーターコンポーネント
 * @class Router
 */
export default function Router() {
  return (
    <SnackbarProvider>
      <BrowserRouter basename="/kb_demo">
        <Routes>
          <Route path="/" element={<Navigate to="/work-contents" />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="work-contents">
            <Route index element={<TopPage />} />
            <Route path="create" element={<WorkContentsCreatePage />} />
            <Route
              path="create/:workType?/:returnWorkId?/:stoplossId?"
              element={<WorkContentsInterruptCreatePage />}
            />
            <Route path="edit/:workId" element={<WorkContentsEditPage />} />
          </Route>
          <Route path="license" element={<LicensePage />} />
        </Routes>
      </BrowserRouter>
    </SnackbarProvider>
  );
}
